import axios from "../axios";

const getBankTransfer = async function (accessToken) {
    try {
        const response = await axios.get('bank-account/getBankTransfer', {
            headers: {
                'Authorization': accessToken
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default getBankTransfer;
